import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDemo } from '../providers/DemoProvider';
import RarityGem from '../../../shared/ui/RarityGem';
import '../../muses/styles/PackOpening.css';

const DemoPackOpening: React.FC = () => {
  const { packToOpen, clearPackToOpen } = useDemo();
  const navigate = useNavigate();
  const [revealed, setRevealed] = React.useState(false);

  useEffect(() => {
    if (!packToOpen) {
      navigate('/demo/market');
      return;
    }
    
    const timer = setTimeout(() => setRevealed(true), 500);
    return () => clearTimeout(timer);
  }, [packToOpen, navigate]);

  const handleDone = () => {
    clearPackToOpen();
    navigate('/demo/mymuses');
  };

  if (!packToOpen) {
    return null; // Or a loading indicator
  }

  return (
    <div className="pack-container">
      <div className="pack-title">🎉 Your New Muses! 🎉</div>
      
      <div className="pack-grid">
        {packToOpen.map((muse, i) => (
          <div 
            key={i} 
            className={`pack-card ${muse.rarity?.toLowerCase()} ${revealed ? 'revealed' : ''}`}
            style={{ transitionDelay: `${i * 0.2}s` }}
          >
            <div className="pack-card-header">
              <RarityGem 
                rarity={muse.rarity} 
                size={32} 
                style={{ marginRight: '12px' }}
              />
              <div className="muse-name">{muse.name}</div>
            </div>
            <div className="pack-card-body">
              <div className="muse-image-container">
                <img 
                  src={muse.img} 
                  alt={muse.name}
                  className="muse-image-large"
                />
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="pack-buttons">
        <button 
          onClick={() => navigate('/demo/market')}
          className="pack-button pack-button-secondary"
        >
          Open More Packs
        </button>
        
        <button 
          onClick={() => navigate('/demo/mymuses')}
          className="pack-button pack-button-primary"
        >
          View in My Muses
        </button>
      </div>
    </div>
  );
};

export default DemoPackOpening;
